import React, { useEffect, useRef } from "react";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import { store } from "main/javascripts/store";
import { HeaderContainer } from "main/javascripts/containers/organisms/Header/HeaderContainer";
import {
  defaultStyles,
  extended,
  GLOBALS,
} from "main/javascripts/styles/globalStyle";
import i18n from "i18n";
import { HOST } from "main/javascripts/constants/Constants";
import { MainHead } from "main/javascripts/components/head/MainHead";
import { useConstructor } from "main/javascripts/hooks/common/useConstructor";
import { useUserAccount } from "main/javascripts/hooks/common/useUserAccount";
import { MainBlock } from "main/javascripts/components/atoms/Block/MainBlock";
import { Footer } from "main/javascripts/components/footer/Footer";
import {
  fetchLpVesselData,
  initLpVessel,
} from "main/javascripts/features/lp/cruise/lpCruiseSlice";
import { Cruise } from "main/javascripts/types/cruise";
import { Region } from "main/javascripts/types/region";
import { LpVesselShowMain } from "main/javascripts/features/lp/cruise/components/LpVesselShowMain";
import { LpCruise } from "main/javascripts/types/lpCruise";

interface IProps {
  vesselCode: string;
  vessel: LpCruise.Vessel;
  cruises: Cruise.Cruise[];
  sales: any[];
  regions: Region.Region[];
  breadcrumbs: any;
  totalNum: number;
  page: number;
  numPerPage: number;
  locale: string;
}

function VesselShow(props: IProps) {
  const {
    vesselCode,
    vessel,
    cruises,
    sales,
    regions,
    breadcrumbs,
    totalNum,
    page,
    numPerPage,
    locale,
  } = props;
  const origin = HOST;

  const isInitializedRef = useRef(false);

  const initializeData = () => {
    store.dispatch(
      initLpVessel({
        vessel,
        cruises,
        sales,
        regions,
        breadcrumbs,
        page,
        numPerPage,
        totalNum,
      })
    );
  };

  useConstructor(() => {
    initializeData();
    if (i18n.language !== locale) {
      void i18n.changeLanguage(locale);
    }
    extended.css(defaultStyles[GLOBALS]);
    isInitializedRef.current = true;
  });

  useEffect(() => {
    // 初期化後にルートが変更された場合再設定する
    if (isInitializedRef.current) {
      initializeData();
    }
  }, [vesselCode]);

  useUserAccount(store);

  return (
    <Provider store={store}>
      <MainHead
        origin={origin}
        title={vessel.metatitle}
        description={vessel.metadescription}
      />
      <I18nextProvider i18n={i18n}>
        <>
          <HeaderContainer />
          <MainBlock>
            <LpVesselShowMain />
          </MainBlock>
          <Footer />
        </>
      </I18nextProvider>
    </Provider>
  );
}

export async function getStaticProps(ctx) {
  const locale = ctx.locale;
  const param = ctx.params;
  const vesselCode = param.vesselCode;
  delete param.vesselCode;
  const data = await store
    .dispatch(
      fetchLpVesselData({
        code: vesselCode,
        isServerSide: true,
      })
    )
    .unwrap();

  return {
    props: {
      locale,
      vesselCode,
      ...data,
    },
    revalidate: 60,
  };
}

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};

export default VesselShow;
